import { render, staticRenderFns } from "./intro.vue?vue&type=template&id=f5250460&scoped=true&"
import script from "./intro.vue?vue&type=script&lang=js&"
export * from "./intro.vue?vue&type=script&lang=js&"
import style0 from "./intro.vue?vue&type=style&index=0&id=f5250460&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5250460",
  null
  
)

export default component.exports